<script lang="ts">
import { defineComponent } from 'vue';

/**
 *
 * @version 1.0.0
 * @since
 */
export default defineComponent({
	name: 'CInfoRow',
	props: {
		title: {
			required: true,
			type: String,
		},
		titleInfo: {
			required: false,
			type: String,
			default: () => '',
		},
		disabled: {
			required: false,
			type: Boolean,
			default: () => false,
		},
		active: {
			required: false,
			type: Boolean,
			default: () => false,
		},
		hasDividerStart: {
			required: false,
			type: Boolean,
			default: false,
		},
		hasDividerEnd: {
			required: false,
			type: Boolean,
			default: true,
		},
		clickAction: {
			required: false,
			type: Function,
			// default: () => null,
		},
	},
});
</script>

<template>
	<div
		:class="[
			'c-info-row',
			{ 'c-info-row--active': active },
			{ 'c-info-row__border-top': hasDividerStart },
			{ 'c-info-row__border-bottom': hasDividerEnd },
			{ 'cursor-pointer': !disabled }
		]"
		@click="!disabled ? clickAction() : () => {}"
	>
		<div :class="['flex-space', 'width-100', 'c-info-row__container', { 'c-info-row--disabled': disabled }]">
			<div class="c-info-row__content">
				<div class="flex-center">
					<h3
						:class="['m-0', 'c-info-row__title']"
					>
						{{ title }}
					</h3>
					<span
						:class="[
							'ml-6',
							'c-info-row__icon',
							{ 'c-info-row__icon--active': active },
							{ 'c-info-row__icon--disabled': disabled },
						]"
					>
						<slot name="iconTitle" />
					</span>
				</div>
				<div
					class="c-info-row__info-text mt-2"
					:title="titleInfo"
				>
					{{ titleInfo }}
				</div>
			</div>
			<div
				:class="['flex-row', 'c-info-row__info', { 'cursor-pointer': !disabled }]"
			>
				<span
					:class="[
						'c-info-row__icon',
						{ 'c-info-row__icon--active': active },
						{ 'c-info-row__icon--disabled': disabled },
					]"
				>
					<slot name="icon" />
				</span>
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
$color-disabled: tokens.$color-gray-aa;

.c-info-row {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding: 12px 16px;

  &:hover {
    background: #CFF4FC;
  }
}

.c-info-row__container {
  gap: 8px;
}

.c-info-row__content {
  @include tools.font-size(14px, 24px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.c-info-row__title {
  @include tools.font-size(14px, 24px);
  color: #6C757D;
}

.c-info-row__border-top {
	border-top: 1px solid #21252940;
}

.c-info-row__border-bottom {
	border-bottom: 1px solid #21252940;
}

.c-info-row__title {
	font-weight: 500;
}

.c-info-row--active {
	background-color: #9EEAF9;
}

.c-info-row--disabled {
	cursor: not-allowed;
	color: $color-disabled;
}

.c-info-row__info {
	max-width: 60%;
	color: tokens.$color-gray-aa;
}

.c-info-row__info-text {
	overflow: hidden;
	text-overflow: ellipsis;
  color: #212529;
}

.c-info-row__icon {
	color: #0000008C;
}

.c-info-row__icon--disabled {
	cursor: not-allowed;
	color: $color-disabled;
}
</style>
